// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__17_wg","row":"ProcedureTreatmentSummary_row__1YDjt"};